import { drop } from "./drop.js";

export const skip = drop;